export const buildPaymentSuccessCallbackUrl = (currentUrl: string) =>
  new URL("/payment/success", currentUrl).toString();

export type OpenPaymentWindow = (
  url?: string | URL,
  target?: string,
  features?: string
) => Window | null;

export type PendingPaymentCheckoutWindow = Pick<
  Window,
  "closed" | "location" | "opener"
>;

export type RedirectPaymentLocation = (url: string) => void;

export const openPendingPaymentCheckoutWindow = (
  openWindow: OpenPaymentWindow = window.open
) => {
  const checkoutWindow = openWindow("about:blank", "_blank");

  if (checkoutWindow) {
    checkoutWindow.opener = null;
  }

  return checkoutWindow;
};

export const redirectToPaymentCheckout = (
  paymentUrl: string,
  checkoutWindow: PendingPaymentCheckoutWindow | null,
  redirectCurrentTab: RedirectPaymentLocation = (url) =>
    window.location.assign(url)
) => {
  if (checkoutWindow && !checkoutWindow.closed) {
    checkoutWindow.location.href = paymentUrl;
    return "new-tab";
  }

  redirectCurrentTab(paymentUrl);
  return "current-tab";
};

export const openPaymentCheckoutLink = (
  paymentUrl: string,
  openWindow: OpenPaymentWindow = window.open
) => openWindow(paymentUrl, "_blank", "noopener,noreferrer");
